import Icon from '@ant-design/icons/lib/components/Icon';

export const RejectedIcon = (props: any) => {
  const icon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="195.002"
      height="195"
      viewBox="0 0 195.002 195"
    >
      <g id="Grupo_720" data-name="Grupo 720" transform="translate(-122 -196)">
        <g
          id="Grupo_591"
          data-name="Grupo 591"
          transform="translate(12.002 23)"
        >
          <path
            id="Unión_4"
            data-name="Unión 4"
            d="M-8326.979,155.01a39.987,39.987,0,0,1,39.987-39.99A39.988,39.988,0,0,1-8247,155.01,39.99,39.99,0,0,1-8286.992,195,39.989,39.989,0,0,1-8326.979,155.01Zm-109.306,28.564a5.712,5.712,0,0,1-5.717-5.712V45.7h39.992a5.708,5.708,0,0,0,5.712-5.714V0h97.88a5.708,5.708,0,0,1,5.714,5.714V104.17a51.528,51.528,0,0,0-36.761,22.276h-72.545a5.708,5.708,0,0,0-5.712,5.712,5.708,5.708,0,0,0,5.712,5.714h66.693a50.52,50.52,0,0,0-2.549,11.424h-64.145a5.708,5.708,0,0,0-5.712,5.714,5.708,5.708,0,0,0,5.712,5.714h64.034a51.145,51.145,0,0,0,8.271,22.85Zm45.7-137.87a22.682,22.682,0,0,0,5.987,15.288,41.082,41.082,0,0,0-23.123,36.89v11.424a5.708,5.708,0,0,0,5.712,5.714h69.318a5.711,5.711,0,0,0,5.712-5.714V97.882a41.081,41.081,0,0,0-23.125-36.89,22.705,22.705,0,0,0,5.987-15.288c0-12.6-10.634-22.852-23.233-22.852S-8390.586,33.1-8390.586,45.7Zm-5.712,57.89V97.882c0-15.75,13.2-29.327,28.947-29.327s28.945,13.576,28.945,29.327v5.712Zm17.138-57.89c0-6.3,5.511-11.426,11.81-11.426s11.808,5.127,11.808,11.426-5.509,11.426-11.808,11.426S-8379.16,52-8379.16,45.7Zm-59.2-11.426a17.953,17.953,0,0,1,1.375-1.674L-8409.4,5.021a16.924,16.924,0,0,1,1.674-1.377V34.278Z"
            transform="translate(8552 173)"
            opacity="0.6"
          />
        </g>
        <g id="Page-1" transform="translate(361 334)">
          <g id="_014---No-Germs" data-name="014---No-Germs">
            <path
              id="Shape"
              d="M22.238,0A22.238,22.238,0,1,0,44.476,22.238,22.238,22.238,0,0,0,22.238,0ZM3.834,22.238A18.394,18.394,0,0,1,33.817,7.944L7.944,33.817a18.3,18.3,0,0,1-4.11-11.579Zm18.4,18.4a18.3,18.3,0,0,1-11.579-4.11L36.531,10.659A18.394,18.394,0,0,1,22.238,40.641Z"
              transform="translate(-106 -6)"
              fill="white"
              stroke="#f5f5f5"
              strokeLinejoin="round"
              strokeWidth="3"
            />
          </g>
        </g>
      </g>
    </svg>
  );
  return <Icon component={icon} {...props} />;
};
